import { transition } from '@helpers/animate';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, from } from '@helpers/media';
import ClearButtonStyles from '@stories/Components/ClearButton/ClearButton.styles';
import styled from 'styled-components';
const Container = styled.div `
  &[data-portrait='true'] {
    @media ${from(Device.MobileLarge)} {
      width: 74%;
    }
  }
`;
const TitleWrapper = styled.div `
  display: flex;
  gap: 24px;
  margin-bottom: 18px;
  align-items: flex-end;
  justify-content: space-between;

  @media ${from(Device.MobileLarge)} {
    align-items: center;
    justify-content: flex-start;
  }

  ${ClearButtonStyles.Container} {
    ${transition('opacity')};

    &[data-visible='false'] {
      opacity: 0;
      pointer-events: none;
    }
  }
`;
const Title = styled.span `
  ${fonts.brandonGrotesque.bold};

  text-transform: uppercase;
  font-size: 16px;
  line-height: 22px;
  border-bottom: 2px solid ${brand.green};
`;
const Options = styled.ul `
  --outerPadding: ${fluid(2, 4)};
  --tagSize: ${fluid(14, 16)};

  display: grid;
  grid-template-rows: 1fr auto;
  gap: 8px;
  padding-bottom: 6px;
  /* Ensure swatches are in line with the title, ignoring the highlight spacing around each swatch */
  margin-left: calc(${fluid(3, 6)} * -1);

  ${Container}[data-portrait='true'] & {
    grid-template-columns: repeat(12, 1fr);
  }

  ${Container}[data-portrait='false'] & {
    grid-template-columns: repeat(4, 1fr);

    @media ${from(Device.MobileLarge)} {
      grid-template-columns: repeat(7, 1fr);
    }

    @media ${from(Device.TabletLarge)} {
      grid-template-columns: repeat(14, 1fr);
    }
  }

  @media ${from(Device.TabletLarge)} {
    gap: 0;
  }

  [data-no-options='true'] ${Container} & {
    @media ${from(Device.TabletLarge)} {
      grid-template-columns: repeat(10, 1fr);
      max-width: calc(100% - 317px);
    }
  }
`;
const Tag = styled.span `
  ${fonts.brandonGrotesque.regular};

  display: inline-flex;
  align-items: center;
  position: absolute;
  top: var(--outerPadding);
  left: var(--outerPadding);
  transform: translateY(-100%);
  font-size: ${fluid(12, 14)};
  line-height: ${fluid(16, 18)};
  text-transform: uppercase;
  height: var(--tagSize);
  padding: 0 6px;
  background-color: #1e1e1e;
  color: ${brand.white};
`;
const Option = styled.li `
  width: 100%;
  display: grid;
  grid-row: span 2;
  grid-template-rows: subgrid;

  &:has(${Tag}) {
    padding-top: var(--tagSize);
  }
`;
const Button = styled.button `
  ${ButtonReset};
  display: block;
  width: 100%;
  text-align: left;
  display: grid;
  grid-row: span 2;
  grid-template-rows: subgrid;

  &[data-disabled='true'] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
const Border = styled.div `
  position: relative;
  padding: var(--outerPadding);
  border: 1px solid;
  background-color: transparent;
  border-color: transparent;
  margin: auto 0 4px;

  ${Container}[data-portrait='true'] & {
    padding-top: ${fluid(4, 8)};
    padding-bottom: ${fluid(4, 8)};
  }

  [data-active='true'] &,
  ${Button}:hover & {
    background-color: ${brand.white};
    border-color: ${brand.green};
  }
`;
const ImageContainer = styled.div `
  ${Container}[data-portrait='false'] & {
    ${imageWrapperPreserveRatio(138, 56)};
  }

  ${Container}[data-portrait='true'] & {
    ${imageWrapperPreserveRatio(73, 116)};
  }
`;
const Image = styled.img `
  ${imageCoverContainer()}

  ${Container}[data-portrait='true'] & {
    object-fit: contain;
  }
`;
const Label = styled.span `
  ${transition('opacity')};
  ${fonts.brandonGrotesque.medium};

  font-size: ${fluid(12, 16)};
  line-height: ${fluid(16, 20)};
  color: ${brand.green};
  display: inline-block;
  margin: 0 auto;

  [data-active='true'] &,
  ${Button}:hover & {
    opacity: 1;
  }

  @media ${from(Device.TabletLarge)} {
    opacity: 0;
  }
`;
const ColourPickerStyles = {
    Border,
    Button,
    Container,
    Image,
    ImageContainer,
    Label,
    Option,
    Options,
    Tag,
    Title,
    TitleWrapper,
};
export default ColourPickerStyles;
